<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <v-card class="ma-3" outlined elevation="2" style="height: 'min-content'">
      <div
        v-if="detailData != null"
        :style="{ padding: '25px', paddingBottom: '10px', fontSize: 'small' }"
      >
        <v-row class="align-center">
          <v-col sm="2">Username</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{
            detailData == null ? '-' : detailData.username
          }}</v-col>
        </v-row>
        <v-row class="align-center">
          <v-col sm="2">Role Name</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ detailData == null ? '-' : detailData.role }}</v-col>
        </v-row>
        <v-row class="align-center" v-if="isView">
          <v-col sm="2">Created Date</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ createdDate }}</v-col>
        </v-row>
      </div>
      <div
        v-else
        :style="{ padding: '25px', paddingBottom: '10px', fontSize: 'small' }"
      >
        <v-row class="align-center">
          <v-col sm="2">Username</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">
            <v-autocomplete
              style="max-width: 350px"
              clearable
              v-model="username"
              :items="itemsUser"
              item-text="username"
              item-value="id"
              return-object
              :loading="loadingUser"
              :search-input.sync="searchUsername"
              @change="getUsername"
              hide-selected
              hide-details="true"
              dense
            />
          </v-col>
        </v-row>
        <v-row class="align-center">
          <v-col sm="2">Role Name</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ isEmpty(username) ? '-' : username.role }}</v-col>
        </v-row>
      </div>
      <v-data-table
        :headers="headers"
        :items="merchants"
        :options.sync="options"
        :server-items-length="totalMerchants"
        :loading="loading"
        loading-text="Loading... Please wait"
        :item-class="rowClass"
        class="d-print-table"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 25, 50],
          // showFirstLastPage: true,
        }"
        sort-by="id"
        :style="{ padding: '10px' }"
        fixed-header
      >
        <template v-slot:[`body.prepend`]>
          <tr>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            />
            <td
              class="pa-3 pl-4 d-block d-sm-table-cell d-print-table-cell fixed-row"
              v-if="!isView"
            />
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.merchant_name"
                type="text"
                label="Nama Merchant/Aggregator"
                v-on:keyup.enter="getData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              />
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.mid"
                type="text"
                label="MID"
                v-on:keyup.enter="getData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              />
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.nmid"
                type="text"
                label="NMID"
                v-on:keyup.enter="getData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              />
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.mpan"
                type="text"
                label="MPAN"
                v-on:keyup.enter="getData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              />
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.city_name"
                type="text"
                label="Kota"
                v-on:keyup.enter="getData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              />
            </td>
            <td
              class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
            >
              <v-text-field
                v-model="search.postal_code"
                type="text"
                label="Kodepos"
                v-on:keyup.enter="getData"
                hide-details="true"
                dense
                prepend-inner-icon="mdi-magnify"
              />
            </td>
          </tr>
        </template>
        <template v-slot:top>
          <v-toolbar flat v-if="!isView">
            <v-chip
              v-if="selectedData.length > 0"
              close
              @click:close="clearSelected"
              :disabled="isView"
            >
              {{ `${selectedData.length} data(s) selected` }}
            </v-chip>
            <div v-else>No data selected.</div>
            <v-spacer />
          </v-toolbar>
        </template>
        <template v-slot:item="{ item, index }">
          <tr
            :key="index"
            :style="{ cursor: 'pointer' }"
            :class="selectedRow == index ? 'indigo lighten-5' : ''"
            @click="selectRow(index)"
          >
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
            </td>
            <td
              class="d-block d-sm-table-cell d-print-table-cell"
              v-if="!isView"
            >
              <v-checkbox
                class="ma-0"
                dense
                hide-details="true"
                v-model="selectedData"
                :value="item.id"
                :disabled="isView"
                :readonly="isView"
              />
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.merchant_name }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.mid }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.nmid }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.mpan }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.city_name }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.postal_code }}
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="clearSearch"
            :disabled="loading"
            :loading="loading"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
      <div class="ma-2 text-center">
        <v-btn
          class="ma-1"
          color="warning"
          @click="() => $router.push('/mapping-mid')"
        >
          back
        </v-btn>
        <v-btn
          v-if="!isView"
          class="ma-1"
          color="success"
          @click="openDialogConfirm"
        >
          save
        </v-btn>
      </div>
    </v-card>
    <v-dialog v-model="dialogConfirm" width="500">
      <v-card>
        <v-card-title> Are you sure want to mapping MID ? </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="() => (dialogConfirm = false)">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="saveMapping"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { dataDelayServiceHit } from '../../store/params';
import { isEmpty, date, showAlert } from '../../lib/helpers';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialogConfirm: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: '#',
        align: 'center',
        value: '#',
        sortable: false,
      },
      {
        text: 'Nama Merchant/Aggregator',
        value: 'merchant_name',
        width: '150',
        align: 'center',
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        align: 'center',
      },
      {
        text: 'NMID',
        value: 'nmid',
        width: '150',
        align: 'center',
      },
      {
        text: 'MPAN',
        value: 'mpan',
        width: '150',
        align: 'center',
      },
      {
        text: 'Kota',
        value: 'city_name',
        width: '250',
        align: 'center',
      },
      {
        text: 'Kode Pos',
        value: 'postal_code',
        width: '150',
        align: 'center',
      },
    ],
    search: {
      merchant_name: '',
      mid: '',
      nmid: '',
      mpan: '',
      city_name: '',
      postal_code: '',
    },
    username: '',
    searchUsername: '',
    selectedRow: '',
    dateFormatted: '',
    dateMenu: false,
    selectedData: [],
    selectAllData: false,
    isView: false,
    isEdit: false,
    createdDate: '',
  }),

  computed: {
    errorValidation() {
      return this.$store.state.rbac.mappingMID.errors;
    },
    loading() {
      return this.$store.state.rbac.mappingMID.loading;
    },
    merchants() {
      return this.$store.state.rbac.mappingMID.allMerchants;
    },
    totalPage() {
      return this.$store.state.rbac.mappingMID.totalPage;
    },
    totalMerchants() {
      return this.$store.state.rbac.mappingMID.totalMerchants;
    },
    detailData() {
      return this.$store.state.rbac.mappingMID.detail;
    },
    loadingUser() {
      return this.$store.state.rbac.mappingMID.loadingUser;
    },
    itemsUser() {
      return this.$store.state.rbac.mappingMID.allUser;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    searchUsername: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getUsername();
        }, dataDelayServiceHit);
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
    selectedData: {
      handler() {
        if (this.selectedData.length > this.maxSelected) {
          showAlert(
            this.$store,
            `Limit selected data is ${this.maxSelected} !`,
            'mdi-alert',
            'red'
          );
          this.selectedData.splice(
            this.maxSelected,
            this.selectedData.length - 1
          );
        }
        this.checkAllSelected();
      },
    },
  },

  mounted() {
    switch (this.$route.params.action) {
      case 'add':
        break;
      case 'view':
        if (isEmpty(this.detailData)) {
          this.$router.push('/mapping-mid');
          return;
        }
        this.headers = this.headers.filter((val) => val.value != '#');
        this.getDetail(this.detailData.user_id, this.detailData.id);
        this.isView = true;
        break;
      case 'edit':
        if (isEmpty(this.detailData)) {
          this.$router.push('/mapping-mid');
          return;
        }
        this.getDetail(this.detailData.user_id, this.detailData.id);
        this.username = {
          username: this.detailData.username,
          id: this.detailData.user_id,
        };
        this.isEdit = true;
        break;
      default:
        this.$router.back();
    }
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.nmid = '';
      this.search.mpan = '';
      this.search.city_name = '';
      this.search.postal_code = '';
      this.getData();
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.merchants.map((val) => val.id);
        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );
        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
        }
      });
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    getUsername() {
      this.$store.dispatch('rbac/mappingMID/getUserByRoleType', {
        date,
        role_type: 'khusus',
        search: {
          username: this.searchUsername,
        },
      });
    },

    getData() {
      this.$store.commit('rbac/mappingMID/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('rbac/mappingMID/fetchMerchants', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          assignedOnly: !!this.isView,
          user_id: this.detailData ? this.detailData.user_id : '0',
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          }
        })
        .finally(() => {
          this.checkAllSelected();
        });
    },

    openDialogConfirm() {
      if (isEmpty(this.username) || this.selectedData.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Username & Merchant must be selected !',
          'mdi-alert',
          'red'
        );
        return;
      }
      this.dialogConfirm = true;
    },

    saveMapping() {
      if (isEmpty(this.username) || this.selectedData.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Username & merhcnat must be selected !',
          'mdi-alert',
          'red'
        );
        return;
      }
      this.$store
        .dispatch('rbac/mappingMID/save', {
          date,
          id: this.selectedData,
          user_id: this.username.id,
          edit: this.isEdit,
        })
        .then((res) => {
          if (res) {
            this.clearSelected();
            showAlert(
              this.$store,
              `${this.isEdit ? 'Edit' : 'Create'} Mapping MID success !`,
              'mdi-check-circle',
              'green'
            );
            this.$router.push('/mapping-mid');
          } else {
            this.$vuetify.goTo(0);
          }
        })
        .finally(() => {
          this.dialogConfirm = false;
        });
    },

    getDetail(user_id, account_id) {
      this.loadingView = true;
      this.$store
        .dispatch('rbac/mappingMID/viewMappingDetail', {
          date,
          user_id,
          account_id,
        })
        .then((res) => {
          if (res) {
            this.selectedData = res.data.list.map((val) => val.id.toString());
            this.createdDate = res.data.created_at;
          }
        })
        .finally(() => {
          this.loadingView = false;
        });
    },

    checkAllSelected() {
      const allIds = this.merchants.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );
      if (
        allSelected.length == 0 &&
        this.selectedData.length > 0 &&
        this.merchants.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },

    closeFlash() {
      this.$store.commit('changePIC/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    isEmpty,
  },
  beforeDestroy() {
    this.$store.commit('rbac/mappingMID/setDetailData', null);
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
